const studentLessonUrl = 'student-lesson';

const studentLessonUrlModifier = 'teacher-view';

const viewByStudentModifier = 'view-by-student';

const viewByQuestionModifier = 'view-by-question';

export { studentLessonUrl, studentLessonUrlModifier, viewByStudentModifier, viewByQuestionModifier };
